<template>
    <div class="login-page">
        <app-navbar></app-navbar>
        <div class="wrapper wrapper-full-page">
        <div class="full-page login-page section-image">
            <div class="content">
            <div class="container">
                <div class="col-lg-4 col-md-6 ml-auto mr-auto">
                    <form @submit.prevent="passwordReset" v-if="!success.state">
                        <card type="login">
                        <h3 slot="header" class="header text-center mb-2">Password Reset</h3>

                        <p>Type in your email address in the box below, you will receive an email with instructions how to reset your password</p>

                        <fg-input v-model="form.email" addon-left-icon="nc-icon nc-single-02"
                                    placeholder="Email Address" v-validate="'required|email'" name="email"></fg-input>
                        <span class="text-danger">{{ errors.first('email') }}</span>

                        <p-button native-type="submit" type="primary" round block class="my-4">Reset</p-button>

                        <router-link class="d-block text-center" to="/login">Click Here to login</router-link>
                        </card>
                    </form>
                    <card type="login" v-if="success.state">
                        <h3 slot="header" class="header text-center mb-2">Password Reset</h3>
                        <p>{{ success.message }}</p>
                    </card>
                </div>
            </div>
            </div>
            <app-footer></app-footer>
            <div class="full-page-background" style="background-image: url(/static/img/background/background-2.jpg) "></div>
        </div>
        </div>
    </div>
</template>
<script>
import { Card, Checkbox, Button } from 'src/components/UIComponents';
import AppNavbar from './Layout/AppNavbar'
import AppFooter from './Layout/AppFooter'
import swal from 'sweetalert2'
import client from '@/util/client'

export default {
    components: {
        Card,
        AppNavbar,
        AppFooter,
        [Checkbox.name]: Checkbox,
        [Button.name]: Button,
    },
    methods: {
        toggleNavbar() {
            document.body.classList.toggle('nav-open')
        },
        closeMenu() {
            document.body.classList.remove('nav-open')
            document.body.classList.remove('off-canvas-sidebar')
        },
        passwordReset() {
            const vm = this
            this.$validator.validate().then( async valid => {
                if (!valid) {
                    return false
                } else {
                    await client.post('/users/user/password/email', {
                        "email": vm.form.email
                    }).then(res => {
                        vm.success.state = true
                        vm.success.message = res.data.message
                    }).catch(e => {
                        swal({
                            title: `There was a problem, please try again.`,
                            buttonsStyling: false,
                            confirmButtonClass: 'btn btn-primary btn-fill'
                        })
                    })
                }
            })
        }
    },
    data() {
        return {
        form: {
            email: '',
        },
        success: {
            state: false,
            message: ''
        }
        }
    },
    beforeDestroy() {
        this.closeMenu()
    }
}
</script>
<style>
</style>
